import React from "react";
import { Badge, IndexTable, Link, Page, Text } from "@shopify/polaris";
import { TitleBar } from "@shopify/app-bridge-react";
import { useTranslation } from "react-i18next";
import PlaceTable from "../../components/PlaceTable";

export default function LocationsIndex(props) {
  const { t } = useTranslation();

  const renderLocation = (
    { id, status, url, name, city, region, country, priority },
    isSelected
  ) => (
    <IndexTable.Row key={id} id={id} selected={isSelected}>
      <IndexTable.Cell>
        <div style={{ padding: "var(--p-space-2) 0px" }}>
          <Link url={url} monochrome removeUnderline>
            <Text  variant="bodyMd" as="span" fontWeight="semibold">{name}</Text>
          </Link>
        </div>
      </IndexTable.Cell>
      <IndexTable.Cell>
        {status == "published" ? (
          <Badge status="success">{t("location.index.published")}</Badge>
        ) : (
          <Badge>{t("location.index.draft")}</Badge>
        )}
      </IndexTable.Cell>
      <IndexTable.Cell>
        <Link monochrome removeUnderline url={city.url}>
          {city.name}
        </Link>
      </IndexTable.Cell>
      <IndexTable.Cell>
        <Link monochrome removeUnderline url={region.url}>
          {region.name}
        </Link>
      </IndexTable.Cell>
      <IndexTable.Cell>
        <Link monochrome removeUnderline url={country.url}>
          {country.name}
        </Link>
      </IndexTable.Cell>
      <IndexTable.Cell>
        {priority || <Text  variant="bodyMd" as="span" color="subdued">{t("location.index.noPrioritySet")}</Text>}
      </IndexTable.Cell>
    </IndexTable.Row>
  );

  const titleBarMarkup = (
    <TitleBar
      title={t("location.index.title")}
      primaryAction={{ content: t("location.index.addLocation"), url: "/places/locations/new" }}
      secondaryActions={[
        {
          content: t("location.index.import"),
          url: "/places/upload/new",
        },
      ]}
    />
  );

  return (
    <Page fullWidth>
      {titleBarMarkup}
      <PlaceTable
        isLocationList={true}
        url={"/locations"}
        renderLocation={renderLocation}
        resourceName={{ 
          singular: t("location.index.resourceSingular"), 
          plural: t("location.index.resourcePlural") 
        }}
        headings={[
          { title: t("location.index.headings.name") },
          { title: t("location.index.headings.status") },
          { title: t("location.index.headings.city") },
          { title: t("location.index.headings.region") },
          { title: t("location.index.headings.country") },
          { title: t("location.index.headings.priority") },
        ]}
      />
    </Page>
  );
}
